var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goodtitlecontainer",style:('color:' + String(_vm.fontcolor))},[_c('div',{staticClass:"goodname"},[_vm._v(_vm._s(_vm.goodname))]),_c('div',{staticClass:"goodinfo"},[_c('h1',[_vm._v(_vm._s(_vm.goodinfo))]),_c('p')])])}
var staticRenderFns = []

export { render, staticRenderFns }